import { processEnv } from 'components/configuration/environmentVariables'
import { StateCreator } from 'zustand'
import { devtools } from 'zustand/middleware'

export const createDevStore = (
    store: StateCreator<any, [], any[]>,
    name?: string
) => (processEnv.NODE_ENV === 'production' ? store : devtools(store, { name }))
